import { Color, Flex, Icon, Spacing, Text, Tooltip } from '@billy/design-system'
import React, { ReactElement } from 'react'

import { ReportSkeleton } from '../../../../../elements/ReportSkeleton'
import { ReportTable } from '../../../../../elements/ReportTable'
import { TableHeader } from '../../../../../elements/TableHeader'
import { useBalanceSheetData } from '../../hooks/useBalanceSheetData'
import { BalanceSheetTableBody } from '../BalanceSheetTableBody'
import { YTDTooltip } from '../YTDTooltip'
import * as Styled from './styles'

const periodsMock = [
  { key: 2025, label: 2025 },
  { key: 2024, label: 2024 },
]

export const BalanceSheetTable = (): ReactElement => {
  const { allExpandableIds, isLoading, periods, reportData } = useBalanceSheetData()

  if (isLoading || !allExpandableIds) {
    return (
      <ReportSkeleton
        headerChildren={
          <>
            {periodsMock.map(({ key, label }) => (
              <Styled.HeaderCell key={key}>
                <Text weight="bold">{label}</Text>
              </Styled.HeaderCell>
            ))}
          </>
        }
        columnWidths={[200, 120, 120]}
      />
    )
  }

  const header = (
    <TableHeader>
      {periods.map(({ key, label, description, start_date: startDate, end_date: endDate }) => {
        return (
          <Styled.HeaderCell key={key}>
            {description ? (
              <Tooltip label={<YTDTooltip startDate={startDate} endDate={endDate} />} placement="bottom">
                <Flex justifyContent="flex-end" alignItems="center" gap={Spacing.S6}>
                  <Text weight="bold">{label}</Text>
                  <Icon icon="info" color={Color.Grey300} />
                </Flex>
              </Tooltip>
            ) : (
              <Text weight="bold">{label}</Text>
            )}
          </Styled.HeaderCell>
        )
      })}
    </TableHeader>
  )

  return (
    <ReportTable allExpandableIds={allExpandableIds} header={header}>
      <BalanceSheetTableBody reportData={reportData} periods={periods} />
    </ReportTable>
  )
}
